import { ModelSearcher } from '@salescore/core'
import { createContext, type ReactNode, useContext, useMemo } from 'react'
import { useRecoilValue } from 'recoil'

import { viewsContextAtom } from '../atoms'

const ModelSearcherContext = createContext<ModelSearcher | undefined>(undefined)

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function ModelSearcherProvider({ children }: { children: ReactNode }): ReactNode {
  const { models } = useRecoilValue(viewsContextAtom)
  const modelSearcher = useMemo(() => new ModelSearcher(models), [models])

  return <ModelSearcherContext.Provider value={modelSearcher}>{children}</ModelSearcherContext.Provider>
}

export const useModelSearcher = (): ModelSearcher => {
  const modelSearcher = useContext(ModelSearcherContext)
  if (modelSearcher === undefined) {
    throw new Error('useModelSearcherはModelSearcherProvider内で使用してください')
  }
  return modelSearcher
}
